<script setup>
import { t } from "@/i18n";
import { FormTextArea } from "@easy/ui/forms";
const prompt = defineModel("prompt", { type: String });

const errorMessage = defineModel("errorMessage");

function filedIsRequired() {
    if (!prompt.value) {
        errorMessage.value = t("shared.creator.prompt_required");
    } else if (prompt.value.length < 10) {
        errorMessage.value = t("shared.creator.prompt_some_more...");
    } else {
        errorMessage.value = "";
    }
}
</script>

<template>
    <FormTextArea
        v-model="prompt"
        :label="$t('shared.description')"
        :placeholder="$t('shared.creator.form_placeholder')"
        :rows="5"
        :blur="filedIsRequired"
        :error="errorMessage"
    />
</template>
